var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v(_vm._s(_vm.title))]),_c('user-route-tabs',{staticClass:"mb-4",attrs:{"user-id":_vm.userId}}),_c('canteen-balances-table',{attrs:{"user-id":_vm.userId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }